import React from "react";
import trophyIcon from "../../assets/images/trophy.png";
import { GET_STATISTICS_QUERY } from "queries/queries";
import { useQuery } from "@apollo/client";
import CoursesProgress from "components/courses/courses-progress";
import CoursePoints from "components/courses/course-points";
import Loading from "components/loading";
import Error from "components/error";
import useMakeScrollable from "custom_hooks/make-scrollable";
import { useHistory } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';

const Points = ({  }) => {
  const { loading, error, data } = useQuery(GET_STATISTICS_QUERY, {
    fetchPolicy: "no-cache"
  });
  const history = useHistory();

  useMakeScrollable()
  if (loading) return <Loading/>;
  if (error) return <Error/>;

  const handleBack = () => {
    history.goBack() 
  };

  const points = data?.statistics?.availablePoints;
  const coursesWithProgress = data.statistics.courseStatistics.filter(course => course.progress > 0);
  return (
    <div className="points scrollable">
      <div className="points-header">
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
        />
        <h2 className="points-header-title">Meine Punkte</h2>
        <div className='points-header-empty'></div>
      </div>
      <div className="points-container">
        <img 
          src={trophyIcon} 
          alt="Trophy Icon"
          className="points-icon"
        />
        <div className="points-number">{points}</div>
        <div className="points-text">Punkte</div>
      </div>
      <CoursesProgress />
      <div className="points-courses">
        {coursesWithProgress.map((course) => (
          <CoursePoints 
            course={course}
            key={course.courseId}
          />
        ))}
      </div>
    </div>
  );
};

export default Points;
